import { forwardRef } from 'react';
import { Button, Card, Chip, Badge, CardActions, CardContent, CardMedia, Grid } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoIcon from '@mui/icons-material/Info';
import Typography from '@mui/material/Typography';
import moment from 'moment/moment';
import MovieIcon from '@mui/icons-material/MovieOutlined';
import './MovieCardDesktop.css'

const MovieCardDesktop = forwardRef(({ movieData, onTimeSlotClick }, ref) => {

  var accessTimeIconStyle = {
    fontSize: "1rem",
    marginBottom: "-.15rem"
  }

  var movieIconStyle = {
    fontSize: "1rem",
    marginBottom: "-.25rem"
  }

  var infoIconStyle = {
    fontSize: "1rem",
  }

  let handleClick = () => {
    window.location.href = `${process.env.PUBLIC_URL}/movies/${movieData.id}`
  }

  let handleTrailerClick = (trailerUrl) => {
    window.open(trailerUrl)
  }

  var binaryData = [];
  binaryData.push(movieData?.cover);

  return (
    <Card sx={{ width: "100%", minHeight: "20rem", boxShadow: "0 0 2px 0 rgb(145 158 171 / 58%), 0 12px 24px -4px rgb(145 158 171 / 54%)"}}>
      <div style={{display: "flex", justifyContent: "center", minHeight: "20rem"}}>
        <div style={{ padding: "0 2rem", marginTop: ".5rem", display: "flex", alignItems: "center"}}>
            <img onClick={handleClick} style={{cursor: "pointer", height:"250px", width: "200px", objectFit: "cover"}} src={`data:image/jpeg;base64,${movieData.coverImg}`}></img>
        </div>
        <div style={{marginRight: "2rem", width: "20rem", display: "flex", flexFlow: "column", justifyContent: "center"}}>
          <h3 style={{margin: "1rem 0 0 0"}}>{movieData.title}</h3><br/>
            <small><b>Durata:</b> <AccessTimeIcon style={accessTimeIconStyle}/> {movieData.duration} min.</small>
            <small><b>Lingua:</b> {movieData.language}</small>
            <small><b>Data di uscita:</b> {moment(movieData.publishedAt).format("DD MMMM YYYY")}</small>
            <small><b>Genere:</b> {movieData.genre}</small><br/>
            {/*movieData.trailer === "" ? <></> : <><small><b>Trailer:</b> <MovieIcon style={movieIconStyle}/> <a target="_blank" href={movieData.trailer}>Vedi</a></small><br/></>*/}
            <div style={{width: "100%"}}>
       {movieData.trailer === "" ? <></> : <><Button variant='outlined' onClick={() => handleTrailerClick(movieData.trailer)} style={{width: "50%", marginBottom: "1rem"}} size="small">Guarda il trailer</Button><br/></>}
      <Button variant='outlined' onClick={handleClick} style={{width: "50%"}} size="small">Visualizza Scheda</Button>
      </div>
          </div>
        <div style={{width: "15rem", display: "flex", flexFlow: "column", justifyContent: "center"}}>
          <div style={{padding: "4rem 0"}}>{movieData.timeTable?.map(tt => {
            return(
              <>
                <h4 style={{margin: ".5rem 0"}}>{moment(tt.date).format("dddd DD MMMM YYYY")}</h4>
                {tt.slots !== undefined && tt.slots.map(s => {
                  return(
                    s.bookable === 0 && moment(tt.date + " " + s.time, "YYYY-MM-DD HH:mm:ss") > moment() && s.availability > 0 && s.availability < 223 ? 
                    <Badge className='preEnd' badgeContent={<span><span>{s.availability}</span>&nbsp;<span style={{fontSize: "8px", marginTop:"5px"}}>POSTI RIMASTI</span></span>} color="primary" style={{marginRight: "1rem", marginTop: ".25rem"}}>
                      <Chip color="primary" disabled={true} label={
                        <div style={{lineHeight: "12px"}}>
                        <span style={{fontSize: "16px"}}><b>{moment(s.time, "HH:mm:ss").format("HH:mm")} </b></span><br/>
                        <span style={{fontSize: "10px"}}>PREVENDITA TERMINATA</span>
                        </div> }></Chip>
                      </Badge>  :
                    s.bookable === 1 && moment(tt.date + " " + s.time, "YYYY-MM-DD HH:mm:ss") > moment() ? <>
                      <Badge badgeContent={s.availability} max={999} color="secondary" style={{marginRight: "1rem", marginTop: ".75rem"}}>
                        <Chip color="primary" onClick={() => onTimeSlotClick(movieData, s, tt.date)} label={<span style={{fontSize: "16px"}}><b>{moment(s.time, "HH:mm:ss").format("HH:mm")}</b></span>}></Chip>
                      </Badge>
                    </> : 
                       <Badge style={{marginRight: "1rem", marginTop: ".25rem"}}>
                      <Chip color="primary" disabled={true} label={<span style={{fontSize: "16px"}}><b>{moment(s.time, "HH:mm:ss").format("HH:mm")}</b></span>}></Chip>
                      </Badge>
                    )
                })}
              </>)  
            })}</div>
       
        </div>
      </div>
          
    </Card>
    
  );
});

export default MovieCardDesktop;
